// extracted by css-extract-rspack-plugin
export default {"cls1":"RotatingPreview-cls1_DNs","cls2":"RotatingPreview-cls2_dDE RotatingPreview-cls1_DNs"};